import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { ErrorDialogData } from './error-dialog/_models/error-dialog-data.model';
import { DialogResult } from '../../models/dialog/dialog-result.model';
import { DialogButton } from '../../enums/dialog-button.enum';
import { IErrorDialogService } from './_interfaces/error-dialog-service.interface';

/**
 *  A service to manage and display error dialogs
 */
@Injectable({
  providedIn: 'root'
})
export class ErrorDialogService implements IErrorDialogService {
  /**
   * @param matDialog - A reference to the MatDialog service
   */
  constructor(private matDialog: MatDialog) {}

  /**
   * Open an error dialog
   * @param title - The title of the error dialog
   * @param message - The message to display to the user
   */
  public async openErrorDialog(
    title: string,
    message: string
  ): Promise<DialogResult<null>> {
    const dialogData = new ErrorDialogData(title, message);
    const dialogRef = this.matDialog.open(ErrorDialogComponent, {
      data: dialogData,
      width: '30rem'
    });
    await dialogRef.afterClosed().toPromise<DialogResult<null>>();
    return new DialogResult(DialogButton.OK);
  }
}
